import '@/installCompositionApi'

import http from '@/helpers/http'
import { mount } from '@/mounter'

import SuggestionLists from './components/SuggestionLists'
import SanitasSearchModule from './SanitasSearchModule'

const config = window.Sanitas?.SanitasSearchProps || {}

http.create({
  axiosConfig: {
    baseURL: '/',
  },
})
mount('search', { SanitasSearchModule, SuggestionLists }, config)
